(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vh-delivery-script"] && !Shopify.designMode) return;
  try {
    class VhDelivery extends HTMLElement {
    connectedCallback() {
      const range = (t) => {
        const n = String(t || '').match(/\d+/g)?.map(Number) || [];
        return n.length ? [n[0], n[n.length - 1]] : null;
      };
      const lead = range(this.dataset.lead);
      const ship = range(this.dataset.ship);
      if (!lead || !ship) return;

      const today = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
      const add = (days) => {
        const d = new Date(today);
        let left = days;
        while (left > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1;
        }
        return d;
      };
      const from = add(lead[0] + ship[0]);
      const to = add(lead[1] + ship[1]);
      const day = new Intl.DateTimeFormat('tr-TR', { day: 'numeric' });
      const full = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long' });
      const text =
        from.getMonth() === to.getMonth()
          ? `${day.format(from)}–${full.format(to)}`
          : `${full.format(from)} – ${full.format(to)}`;
      const out = this.querySelector('[data-range]');
      if (!out) return;
      out.textContent = text;
      this.querySelector('[data-date]').hidden = false;
    }
  }
  if (!customElements.get('vh-delivery')) customElements.define('vh-delivery', VhDelivery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vh-email-popup"] && !Shopify.designMode) return;
  try {
    class VhEmailPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      const KEY = 'vh-popup';
      const read = () => {
        try {
          return JSON.parse(localStorage.getItem(KEY) || '{}');
        } catch (e) {
          return {};
        }
      };
      const write = (v) => {
        try {
          localStorage.setItem(KEY, JSON.stringify({ ...read(), ...v }));
        } catch (e) {
          /* depolama kapalı */
        }
      };
      this.write = write;
      this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close(7)));
      this.dialog.addEventListener('cancel', () => write({ until: Date.now() + 7 * 864e5 }));
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.close(7);
      });

      /* Gönderim sonrası (başarı ya da hata) pencere hemen açık gelir */
      if (this.hasAttribute('data-posted')) {
        write({ until: Date.now() + 365 * 864e5 });
        this.open();
        return;
      }
      if (this.hasAttribute('data-error')) {
        this.open();
        return;
      }

      const state = read();
      if (state.until && state.until > Date.now()) return;
      const views = (state.views || 0) + 1;
      write({ views });
      const delay = Math.max(5, Number(this.dataset.delay) || 30) * 1000;
      if (views >= 2) setTimeout(() => this.tryOpen(), 2500);
      else setTimeout(() => this.tryOpen(), delay);
    }

    /* Başka bir pencere, çekmece ya da çerez bandı açıkken bekler */
    tryOpen(attempt = 0) {
      const busy =
        document.querySelector('dialog[open]:not(.vh-popup)') ||
        document.querySelector('#shopify-pc__banner:not([hidden])')?.offsetParent ||
        document.querySelector('.sticky-add-to-cart__bar[data-stuck="true"]');
      if (busy) {
        if (attempt < 20) setTimeout(() => this.tryOpen(attempt + 1), 3000);
        return;
      }
      this.open();
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.dialog.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    }

    close(days) {
      this.write({ until: Date.now() + days * 864e5 });
      this.dialog.close();
    }
  }
  if (!customElements.get('vh-email-popup')) customElements.define('vh-email-popup', VhEmailPopup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vh-pdp-sync"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__vhPdpSync) return;
    window.__vhPdpSync = true;
    document.addEventListener('shopify:product:select', (event) => {
      const target = event.target;
      if (!(target instanceof Element) || target.closest('product-card, quick-add-dialog')) return;
      Promise.resolve(event.promise)
        .then((result) => {
          const html = result?.detail?.html;
          if (!html) return;
          document.querySelectorAll('[data-vh-sync]').forEach((el) => {
            const next = html.querySelector(`[data-vh-sync="${el.dataset.vhSync}"]`);
            if (next && next.innerHTML !== el.innerHTML) el.innerHTML = next.innerHTML;
          });
          document.dispatchEvent(new CustomEvent('vh:variant-synced', { detail: { html } }));
        })
        .catch(() => {});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vh-scroller"] && !Shopify.designMode) return;
  try {
    class VhScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vh-scroller__track');
      if (!this.track) return;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelectorAll('.vh-scroller__arrow').forEach((b) =>
        b.addEventListener('click', () => {
          const item = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
          const step = item ? item.getBoundingClientRect().width + gap : 300;
          this.track.scrollBy({ left: step * Number(b.dataset.dir), behavior: this.reduce ? 'auto' : 'smooth' });
        })
      );

      const items = [...this.track.children].filter((li) => li.querySelector('video'));
      items.forEach((li) => {
        const video = li.querySelector('video');
        const btn = li.querySelector('[data-vh-toggle]');
        video.muted = true;
        const sync = () => {
          const playing = !video.paused;
          li.toggleAttribute('data-playing', playing);
          if (btn) btn.setAttribute('aria-label', playing ? btn.dataset.pauseLabel : btn.dataset.playLabel);
        };
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        btn?.addEventListener('click', () => {
          li.dataset.user = '1';
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        });
      });
      if (!items.length || this.reduce || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            const video = e.target.querySelector('video');
            if (e.target.dataset.user) return;
            if (e.isIntersecting) {
              video.preload = 'auto';
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.6 }
      );
      items.forEach((li) => this.io.observe(li));
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }
  }
  if (!customElements.get('vh-scroller')) customElements.define('vh-scroller', VhScroller);
  } catch(e) { console.error(e); }
})();

})();
